export default "__VITE_ASSET__I1fr_StK__"